export default {"src":"/_next/static/media/pause-video.1feee183.svg","height":18,"width":14};